import React from "react";
import { Box } from "@mui/material";
import ReviewForm from "./ReviewForm";

const ManagerDashboard = () => {
  return (
    <Box sx={{ width: "100%", mt: 8 }}>
      {/* Main Content */}
      <ReviewForm />
    </Box>
  );
};

export default ManagerDashboard;
